import { localStorageAdapter } from "commons/LocalStorageAdapter/LocalStorageAdapter";

const localStorageAdapterObject = localStorageAdapter();

const KidsMode = {
  isActive() {
    return localStorageAdapterObject.getItem("kids") === "true"
  },
  activate() {
    localStorageAdapterObject.setItem('kids', true);
    document.querySelector("body").classList.add('kids-mode');
  },
  deactivate() {
    localStorageAdapterObject.setItem('kids', false);
    document.querySelector("body").classList.remove('kids-mode');
  }
}

export default KidsMode;
